import Marquee from "react-fast-marquee";

const items = ["Content Creation", "Social Media", "Website Design", "Google My Business", "Reels & Video", "Brand Strategy"];

export default function BrandMarquee() {
  return (
    <section className="border-y border-slate-200 bg-white py-8">
      <Marquee speed={40} gradient={false} autoFill>
        {items.map((it, i) => (
          <div key={i} className="flex items-center">
            <span className="marquee-outline px-8 font-display text-4xl font-extrabold uppercase tracking-tight md:text-6xl">
              {it}
            </span>
            <span className="h-3 w-3 rounded-full bg-lab-green" />
          </div>
        ))}
      </Marquee>
    </section>
  );
}
